import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React, { PureComponent } from "react";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography"; //Limitless imports

var MarketingCard = /*#__PURE__*/function (_PureComponent) {
  _inherits(MarketingCard, _PureComponent);

  var _super = _createSuper(MarketingCard);

  function MarketingCard() {
    _classCallCheck(this, MarketingCard);

    return _super.apply(this, arguments);
  }

  _createClass(MarketingCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          img = _this$props.img,
          title = _this$props.title,
          buttonTitle = _this$props.buttonTitle,
          desc = _this$props.desc,
          backgroundColor = _this$props.backgroundColor,
          contrastColour = _this$props.contrastColour,
          id = _this$props.id;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Card, {
        className: classes.card
      }, /*#__PURE__*/React.createElement(CardMedia, {
        className: classes.media,
        image: img,
        style: {
          backgroundColor: backgroundColor,
          padding: 5
        }
      }), /*#__PURE__*/React.createElement(CardContent, {
        className: classes.cardContent
      }, /*#__PURE__*/React.createElement(Typography, {
        style: {
          color: contrastColour
        },
        variant: "h6"
      }, title), /*#__PURE__*/React.createElement(Typography, {
        style: {
          color: contrastColour
        },
        component: "p"
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: desc
        }
      }))), /*#__PURE__*/React.createElement(CardActions, {
        className: classes.cardActions
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: this.props.buttonClickHandle,
        id: "mediaCardButton".concat(id)
      }, buttonTitle))));
    }
  }]);

  return MarketingCard;
}(PureComponent);

var styles = {
  card: {
    width: 240,
    marginBottom: 40
  },
  media: {
    height: 150,
    backgroundSize: "contain"
  },
  cardActions: {
    justifyContent: "center"
  }
};
export default withStyles(styles)(MarketingCard);